<!-- eslint-disable-next-line vue/valid-template-root-->
<template></template>

<script>
let meta;
export default {
  name: 'meta-tag',
  data() {
    return {
      default_title: 'Review SOCO by Sociolla - Review produk kecantikan terlengkap',
      default_site_name: 'Review SOCO by Sociolla',
      default_description:
        'Situs review terlengkap seputar produk kecantikan. Dapatkan ulasan terpercaya tentang skin care, hair care, makeup accessories, body care hingga fragrance, mulai dari brand lokal hingga Internasional di sini!',
      default_short_description: 'SOCO by Sociolla - Situs review kecantikan terlengkap wanita',
      default_ogType: 'website',
      default_image: 'https://soc-dashboard.s3-ap-southeast-1.amazonaws.com/review-assets/review-cover.jpg',
      default_keyword:
        'review produk kecantikan, review sociolla, review produk kecantikan yang bagus, review, ulasan produk kecantikan',
    };
  },
  computed: {
    title() {
      try {
        if (this.currentPageIn([''])) {
          return this.default_title;
        } else if (this.currentPageIn(['Brands'])) {
          return `Review Brand Lokal dan International - ${this.default_site_name}`;
        } else if (this.currentPageIn(['BrandDetailOrigin'])) {
          return `Review produk dan brand dari ${this.headerMeta.country}`;
        } else if (this.currentPageIn(['BrandsLetter'])) {
          return `Review ${this.$route.params.letter ? this.$route.params.letter.toUpperCase() + ' ' : ''}Brands - ${
            this.default_site_name
          }`;
        } else if (this.currentPageIn(['BrandDetail'])) {
          if (this.headerMeta.name) {
            return `${this.headerMeta.name} - ${this.default_site_name}`;
          } else {
            return this.headerTitle ? this.headerTitle : this.default_site_name;
          }
        } else if (this.currentPageIn(['productDetail'])) {
          if (this.headerMeta.name) {
            return `${this.headerMeta ? this.headerMeta.brand.name : ''} ${
              this.headerMeta ? this.headerMeta.name : ''
            } - ${this.default_site_name}`;
          } else {
            return this.headerTitle ? this.headerTitle : this.default_site_name;
          }
        } else if (this.currentPageIn(['Category'])) {
          return `${this.$options.filters.deslug(this.$route.params.category_name)} - ${this.default_site_name}`;
        } else if (this.currentPageIn(['AddProduct'])) {
          return `Add Product - ${this.default_site_name}`;
        } else if (this.currentPageIn(['Search'])) {
          return `You searched for ${this.$options.filters.deslug(this.$route.query.query)} - ${
            this.default_site_name
          }`;
        } else if (this.currentPageIn(['WriteReview'])) {
          return `Write Review for ${this.selectedProduct ? this.selectedProduct.name : ''} - ${
            this.default_site_name
          }`;
        } else {
          return this.default_title;
        }
      } catch (e) {
        return this.default_title;
      }
    },
    title_for_webpage() {
      try {
        if (this.currentPageIn(['BrandDetail'])) {
          return `${this.headerMeta.name ? this.headerMeta.name : ''}`;
        } else {
          return this.default_title;
        }
      } catch (e) {
        return this.default_title;
      }
    },
    description() {
      try {
        if (this.currentPageIn(['productDetail'])) {
          const product = this.headerMeta;
          if (product.description) {
            return this.$options.filters.stripHTML(product.description);
          } else if (product.content) {
            return this.$options.filters.stripHTML(product.content);
          } else {
            if (product.name) {
              return `Review ${product.name} dipersembahkan oleh SOCO by Sociolla.Situs review terlengkap seputar produk kecantikan. Mulai dari brand lokal hingga Internasional, dapatkan ulasan terpercaya tentang ${product.name} di sini!`;
            } else if (this.$SO.size(this.metaHighestReview)) {
              return `${this.metaHighestReview.detail} | ${product.name}`;
            } else {
              if (product.brand && product.brand.description) {
                return this.$options.filters.stripHTML(product.brand.description);
              } else {
                return this.default_description;
              }
            }
          }
          // let product = this.headerMeta
          // let rating = (product.review_stats && product.review_stats.average_rating) ? Number(product.review_stats.average_rating).toFixed(1) : 0
          // return `★ ${rating} of 5 from ${product.review_stats ? product.review_stats.total_reviews: 0} reviewer | ${product.brand ? product.brand.name : ''} ${product.name}`
        } else if (this.currentPageIn(['BrandDetail'])) {
          const brand = this.headerMeta;
          if (brand) {
            if (brand.description) {
              return this.$options.filters.stripHTML(brand.description);
            } else if (brand.short_description) {
              return this.$options.filters.stripHTML(brand.short_description);
            } else if (brand.name) {
              return `${brand.name} Review dipersembahkan oleh SOCO by Sociolla.Situs review terlengkap seputar produk kecantikan. Mulai dari brand lokal hingga Internasional, dapatkan ulasan terpercaya tentang brand ${brand.name} di sini!`;
            }
          } else {
            return this.default_description;
          }
        } else if (this.currentPageIn(['BrandDetailOrigin'])) {
          const brand = this.headerMeta;
          if (brand) {
            return `Temukan ulasan terpercaya produk-produk dan brand dari ${brand.country}, Hanya di Review SOCO by Sociolla.`;
          } else {
            return this.default_description;
          }
        } else if (this.currentPageIn(['Brands', 'BrandsLetter'])) {
          return `Review brands dipersembahkan oleh SOCO by Sociolla.Situs review terlengkap seputar produk kecantikan. Mulai dari brand lokal hingga Internasional, dapatkan ulasan terpercaya tentang semua brand di sini!`;
        } else if (this.currentPageIn(['Category'])) {
          // var category = this.headerMeta;
          if (this.$route.params.category_name) {
            const category_name = this.$options.filters.deslug(this.$route.params.category_name);
            return `${category_name} Review SOCO by Sociolla. Situs review terlengkap seputar produk kecantikan. Mulai dari brand lokal hingga Internasional, dapatkan ulasan terpercaya tentang ${category_name} di sini!`;
          } else {
            return this.default_description;
          }
        } else if (this.currentPageIn(['Search'])) {
          return `Pencarian ${this.$options.filters.deslug(
            this.$route.query.query
          )} dipersembahkan oleh Review SOCO by Sociolla. Situs review terlengkap seputar produk kecantikan. Mulai dari brand lokal hingga Internasional, dapatkan ulasan terpercaya tentang skin care, hair care, makeup accessories, body care hingga fragrance di sini!`;
        } else if (this.currentPageIn(['WriteReview'])) {
          let product_name = '';
          let brand_name = '';
          if (this.selectedProduct) {
            product_name = this.selectedProduct.name;
            if (this.selectedProduct.brand) {
              brand_name = this.selectedProduct.brand.name;
            }
          }
          return `Tulis reviewmu untuk produk ${product_name} dari ${brand_name}, dipersembahkan oleh Review SOCO by Sociolla, Situs review terlengkap seputar produk kecantikan terpercaya di Indonesia`;
        } else {
          return this.default_description;
        }
      } catch (e) {
        console.log(e);
        return this.default_description;
      }
      return this.default_description;
    },
    description_for_webpage() {
      try {
        if (this.currentPageIn(['BrandDetail'])) {
          return `${
            this.$options.filters.stripHTML(this.headerMeta.short_description)
              ? this.$options.filters.stripHTML(this.headerMeta.short_description)
              : this.$options.filters.stripHTML(this.headerMeta.description)
          }`;
        } else {
          return this.default_short_description;
        }
      } catch (e) {
        return this.default_short_description;
      }
    },
    short_description() {
      if (this.currentPageIn(['AddProduct', 'productDetail'])) {
        return `SOCO by Sociolla`;
      } else {
        return this.default_short_description;
      }
    },
    ogType() {
      if (this.currentPageIn(['productDetail'])) {
        return `product`;
      }
      return this.default_ogType;
    },
    headerMeta() {
      return this.$store.state.header.meta;
    },
    headerTitle() {
      return this.$store.state.header.title;
    },
    metaHighestReview() {
      return this.$store.state.header.metaHighestReview;
    },
    image() {
      try {
        if (this.currentPageIn(['productDetail'])) {
          let cover_image = (this.headerMeta.images || []).find((el) => el.is_cover) || {};
          if (!Object.keys(cover_image).length) {
            const combImage = this.headerMeta.combinations || [];
            cover_image = combImage.flatMap((el) => el.images).find((el) => el.is_cover);
          }
          if (this.$SO.size(cover_image)) {
            return cover_image.url;
          } else {
            return `${this.$store.state.REVIEW_WEB_URL}/assets/img/dummy_product.svg`;
          }
        } else if (this.currentPageIn(['BrandDetail'])) {
          if (this.$SO.size(this.headerMeta) && this.headerMeta.logo) {
            return this.headerMeta.logo;
          } else {
            return `${this.$store.state.REVIEW_WEB_URL}/assets/img/default_img_brand.svg`;
          }
        } else {
          return this.default_image;
        }
      } catch (error) {
        return this.default_image;
      }
    },
    url() {
      return `${this.$store.state.REVIEW_WEB_URL}${this.$route.fullPath}`;
    },
    ampLink() {
      const domainRegex = new RegExp(this.$store.state.REVIEW_WEB_URL, 'gi');
      const constructAMPUrl = '/amp' + this.url.replace(domainRegex, '');
      return `${this.$store.state.REVIEW_WEB_URL}${constructAMPUrl}`;
    },
    selectedProduct() {
      if (this.$SO.size(this.$store.state.writeReview.selectedProduct)) {
        return this.$store.state.writeReview.selectedProduct;
      } else {
        return { name: '' };
      }
    },
    keyword() {
      if (this.currentPageIn(['Brands', 'BrandsLetter'])) {
        const result = `brand, ${
          this.$route.params.letter ? this.$route.params.letter.toUpperCase() + ', ' : ''
        }merk kecantikan, review terpercaya, lokal, internasional, review brand kecantikan`;

        if (this.headerMeta) {
          if (this.headerMeta.meta_keyword) {
            result = this.headerMeta.meta_keyword;
          }
        }

        return result;
      } else if (this.currentPageIn(['BrandDetail'])) {
        let result = '';
        let brand_name = '';

        if (this.headerMeta) {
          brand_name = this.headerMeta.name;
          if (brand_name) {
            brand_name = brand_name.toLowerCase();
          }
          result = `${brand_name}, review, review brand kecantikan`;
          if (this.headerMeta.meta_keyword) {
            result = this.headerMeta.meta_keyword;
          }
        }

        return result;
      } else if (this.currentPageIn(['BrandDetailOrigin'])) {
        const result = '';
        let brand_country = '';

        if (this.headerMeta) {
          brand_country = this.headerMeta.country;
          if (brand_country) {
            brand_country = brand_country.toLowerCase();
          }
          result = `Review produk kecantikan dan brand dari ${brand_country}`;
        }

        return result;
      } else if (this.currentPageIn(['productDetail'])) {
        let product_name = '';
        let brand_name = '';
        if (this.headerMeta) {
          product_name = this.headerMeta.name;
          if (product_name) {
            product_name = product_name.toLowerCase();
          }
          brand_name = this.headerMeta.brand.name;
          if (brand_name) {
            brand_name = brand_name.toLowerCase();
          }
        }
        return `${brand_name}, ${product_name}, review, review produk kecantikan`;
      } else if (this.currentPageIn(['Category'])) {
        let category_name = this.$options.filters.deslug(this.$route.params.category_name);
        if (category_name) {
          category_name = category_name.toLowerCase();
        }
        return `${category_name}, review, review produk kecantikan`;
      } else if (this.currentPageIn(['AddProduct'])) {
        // return `review, soco, sociolla, produk, kecantikan, beauty, brand, lokal, internasional, skincare, haircare, makeup accessories, body care, fragrance, trusted, terpercaya.`
        return `review produk kecantikan, review sociolla, review produk kecantikan yang bagus, review, Ulasan produk kecantikan`;
      } else if (this.currentPageIn(['Search'])) {
        return `${this.$options.filters.deslug(
          this.$route.query.query
        )}, review, review produk kecantikan, review produk kecantikan terpercaya`;
      } else if (this.currentPageIn(['WriteReview'])) {
        // var product_name = ''
        // var brand_name = ''
        // if (this.selectedProduct) {
        // 	product_name = this.selectedProduct.name
        // 	if (product_name) {
        // 		product_name = product_name.toLowerCase()
        // 	}
        // 	if (this.selectedProduct.brand) {
        // 		brand_name = this.selectedProduct.brand.name
        // 		if (brand_name) {
        // 			brand_name = brand_name.toLowerCase()
        // 		}
        // 	}
        // }
        // return `tulis review, ${product_name}, ${brand_name}, review, review produk kecantikan, review produk kecantikan terpercaya`
        return `review produk kecantikan, review sociolla, review produk kecantikan yang bagus, review, Ulasan produk kecantikan`;
      } else {
        return this.default_keyword;
      }
    },
    list_products() {
      const result = [];

      if (this.$store.state.product.list_products && this.$store.state.product.list_products.length) {
        return this.$store.state.product.list_products;
      }

      return result;
    },
    reviewDetail() {
      return this.$store.state.reviewDetail;
    },
    isHaveReviewDetail() {
      return Boolean(Object.keys(this.reviewDetail).length);
    },
  },
  methods: {
    currentPageIn(pages) {
      const routeNames = [];
      pages.forEach((page) => {
        if (page === '') {
          routeNames.push('Dashboard');
        }
        if (page === 'AddProduct') {
          routeNames.push('AddProduct');
        }
        if (page === 'Brands') {
          routeNames.push('Brands');
        }
        if (page === 'BrandsLetter') {
          routeNames.push('BrandsLetter');
        }
        if (page === 'BrandDetail') {
          routeNames.push('BrandDetail');
        }
        if (page === 'productDetail') {
          routeNames.push('productDetail');
        }
        if (page === 'Category') {
          routeNames.push('Category');
        }
        if (page === 'Search') {
          routeNames.push('Search');
        }
        if (page === 'WriteReview') {
          routeNames.push('WriteReview');
        }
        if (page === 'BrandDetailOrigin') {
          routeNames.push('BrandDetailOrigin');
        }
        if (page === 'ReviewDetail') {
          routeNames.push('ReviewDetail');
        }
      });
      return routeNames.some((route) => (this.$route.name === route ? true : false));
    },
  },
  metaInfo() {
    let ldjsonContent;
    meta = {
      title: `${this.title ? this.title : ''}`,
      meta: [
        { name: 'title', content: `${this.title ? this.title : ''}` },
        { name: 'description', content: this.description },
        { name: 'keyword', content: this.keyword },
        { property: 'og:url', content: this.url },
        { property: 'og:image', content: this.image },
        { property: 'og:image:alt', content: `${this.title}` },
        { property: 'og:type', content: this.ogType },
        { property: 'og:title', content: `${this.title}` },
        { property: 'og:description', content: this.description },
        { property: 'og:locale', content: 'en_US' },
        { property: 'og:site_name', content: this.default_site_name },
        { property: 'fb:app_id', content: `1030272380362840` },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: '@beautyjournalid' },
        { name: 'twitter:creator', content: '@beautyjournalid' },
        { name: 'twitter:title', content: `${this.title}` },
        { name: 'twitter:description', content: this.description },
        { name: 'twitter:image', content: this.image },
      ],
    };

    if (this.currentPageIn(['productDetail', 'BrandDetail', 'Category'])) {
      meta.link = [{ rel: 'amphtml', href: `${this.ampLink}` }];
    }

    if (this.currentPageIn(['productDetail', 'BrandDetail'])) {
      const content = this.currentPageIn(['productDetail']) ? this.title : 'Review SOCO by Sociolla';
      meta.meta[5] = {
        property: 'og:image:alt',
        content: content,
      };
      meta.meta[9] = {
        property: 'og:site_name',
        content: this.default_site_name,
      };
    }

    if (this.currentPageIn(['AddProduct'])) {
      meta.meta[6].content = `Review - Add Product | SOCO by Sociolla - Situs review kecantikan terlengkap wanita.`;
    }

    if (this.currentPageIn(['WriteReview'])) {
      meta.title = `Write Review for ${this.selectedProduct.name} | SOCO by Sociolla`;
    }

    if (this.currentPageIn([''])) {
      ldjsonContent = {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        name: `${this.default_site_name}`,
        // "description": this.default_short_description,
        url: this.$store.state.REVIEW_WEB_URL,
        // "sameAs": [
        // 	"https://www.sociolla.com/",
        // 	"https://lilla.sociolla.com/",
        // 	"https://www.soco.id/",
        // 	"https://twitter.com/sociolla_id",
        // 	"https://www.facebook.com/sociolla",
        // 	"https://www.instagram.com/sociolla/",
        // 	"https://www.youtube.com/channel/UC7mQM7kjGT1Q0-5j1sv4VMg",
        // 	"https://line.me/ti/p/%40lcu1578a"
        // ],
        potentialAction: {
          '@type': 'SearchAction',
          target: `${this.$store.state.REVIEW_WEB_URL}/search?query={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      };
      ldjsonContent = JSON.stringify(ldjsonContent);
    }

    if (this.currentPageIn(['productDetail'])) {
      // WebSite
      ldjsonContent = {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        name: `${this.default_site_name}`,
        // "description": this.default_short_description,
        url: this.$store.state.REVIEW_WEB_URL,
        // "sameAs": [
        // 	"https://www.sociolla.com/",
        // 	"https://lilla.sociolla.com/",
        // 	"https://www.soco.id/",
        // 	"https://twitter.com/sociolla_id",
        // 	"https://www.facebook.com/sociolla",
        // 	"https://www.instagram.com/sociolla/",
        // 	"https://www.youtube.com/channel/UC7mQM7kjGT1Q0-5j1sv4VMg",
        // 	"https://line.me/ti/p/%40lcu1578a"
        // ],
        potentialAction: {
          '@type': 'SearchAction',
          target: `${this.$store.state.REVIEW_WEB_URL}/search?query={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      };

      ldjsonContent = JSON.stringify(ldjsonContent);
    }

    const ldjson_temp = {
      script: [],
    };
    if (this.currentPageIn(['BrandDetail', 'Search', 'Category'])) {
      if (this.currentPageIn(['BrandDetail'])) {
        const listProductsBrand = [];
        // Organization
        ldjsonContent = {
          '@context': 'http://schema.org',
          '@type': 'Brand',
          name: this.headerMeta.name,
          description: this.headerMeta.description ? this.headerMeta.description : this.description_for_webpage,
          url: this.url,
          logo: this.image,
          aggregateRating: {
            '@type': 'aggregateRating',
            ratingValue: '5',
            reviewCount: this.headerMeta.total_reviews,
          },
        };

        ldjsonContent = JSON.stringify(ldjsonContent);
        ldjson_temp.script.push({
          innerHTML: ldjsonContent,
          type: 'application/ld+json',
        });

        this.$SO.each(this.list_products, (key, product) => {
          const listjsonldObject = {
            '@type': 'ListItem',
            position: key + 1,
            url: `${this.$store.state.REVIEW_WEB_URL}${this.$options.filters.productUrlReview(product)}`,
            name: product.name,
            // "image": product.images.length && product.images[0].url ? product.images[0].url : `${this.$store.state.REVIEW_WEB_URL}/assets/img/dummy_product.svg`,
            // "description": product.description ? this.$options.filters.stripHTML(product.description) : '',
            // "brand": {
            // 	"@type": "Brand",
            // 	"name": product.brand.name ? product.brand.name : ''
            // },
            // "aggregateRating": {
            // 	"@type": "aggregateRating",
            // 	"ratingValue": this.$options.filters.productrating(product.review_stats.average_rating),
            // 	"reviewCount": product.review_stats.total_reviews
            // }
          };

          // if ('sku' in product && product.sku) {
          // 	listjsonldObject.sku = product.sku
          // }
          // if ('ean_no' in product.default_combination && product.default_combination.ean_no) {
          // 	listjsonldObject.gtin = product.default_combination.ean_no
          // }

          listProductsBrand.push(listjsonldObject);
        });

        if (this.$SO.size(this.list_products)) {
          ldjsonContent = {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            numberOfItems: String(this.list_products.length),
            itemListElement: listProductsBrand,
          };

          ldjsonContent = JSON.stringify(ldjsonContent);
          ldjson_temp.script.push({
            innerHTML: ldjsonContent,
            type: 'application/ld+json',
          });
        }
      }

      if (!this.currentPageIn(['BrandDetail']) && !this.currentPageIn(['Category'])) {
        // WebSite
        ldjsonContent = {
          '@context': 'http://schema.org',
          '@type': 'WebSite',
          name: `${this.default_site_name}`,
          // "description": this.default_short_description,
          url: this.$store.state.REVIEW_WEB_URL,
          // "sameAs": [
          // 	"https://www.sociolla.com/",
          // 	"https://lilla.sociolla.com/",
          // 	"https://www.soco.id/",
          // 	"https://twitter.com/sociolla_id",
          // 	"https://www.facebook.com/sociolla",
          // 	"https://www.instagram.com/sociolla/",
          // 	"https://www.youtube.com/channel/UC7mQM7kjGT1Q0-5j1sv4VMg",
          // 	"https://line.me/ti/p/%40lcu1578a"
          // ],
          potentialAction: {
            '@type': 'SearchAction',
            target: `${this.$store.state.REVIEW_WEB_URL}/search?query={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        };

        ldjsonContent = JSON.stringify(ldjsonContent);
        ldjson_temp.script.push({
          innerHTML: ldjsonContent,
          type: 'application/ld+json',
        });
      }

      // List Product Brand
      let categoriesBreadcumb = [];
      if (
        this.list_products &&
        this.list_products.length &&
        !this.currentPageIn(['BrandDetail']) &&
        !this.currentPageIn(['Category'])
      ) {
        const products = this.list_products;

        for (let i = 0; i < products.length; i++) {
          const item_product = products[i];
          if (item_product) {
            if (i == 0) {
              // eslint-disable-next-line no-unused-vars
              categoriesBreadcumb = item_product.categories;
            }

            const json_image = item_product.images.find((e) => e.is_cover) || item_product.images[0] || {};

            const jsonldObject = {
              '@context': 'http://schema.org/',
              '@type': 'Product',
              name: item_product.name ? item_product.name : '',
              image: [json_image.url || ''],
              description: item_product.description ? this.$options.filters.stripHTML(item_product.description) : '',
              brand: {
                '@type': 'Brand',
                name: item_product.brand.name ? item_product.brand.name : '',
              },
            };

            let finalPrice = 0;
            if (
              item_product.default_combination.price_after_discount < item_product.default_combination.price &&
              item_product.default_combination.price_after_discount &&
              item_product.default_combination.deduction_type
            ) {
              finalPrice = item_product.default_combination.price_after_discount;
            } else {
              finalPrice = item_product.default_combination.price;
            }

            if (finalPrice && item_product.is_active_in_sociolla) {
              jsonldObject.offers = {
                '@type': 'Offer',
                price: parseInt(finalPrice),
                priceCurrency: 'IDR',
                itemCondition: 'NewCondition',
                availability: `${Number(item_product.stock) > 0 ? 'InStock' : 'OutOfStock'}`,
                seller: {
                  '@type': 'Organization',
                  name: 'Sociolla',
                },
                url: item_product.url_share,
              };
            }

            if ('sku' in item_product && item_product.sku) {
              jsonldObject.sku = item_product.sku;
            }
            if ('ean_no' in item_product.default_combination && item_product.default_combination.ean_no) {
              jsonldObject.gtin = item_product.default_combination.ean_no;
            }
            if (item_product.review_stats.total_reviews > 0) {
              let average = 0;
              if (this.$SO.size(item_product.review_stats) && item_product.review_stats.average_rating) {
                average = this.$options.filters.productrating(item_product.review_stats.average_rating);
              }
              jsonldObject.aggregateRating = {
                '@type': 'AggregateRating',
                ratingValue: Number(average),
                reviewCount: item_product.review_stats.total_reviews,
              };
            } else {
              jsonldObject.aggregateRating = {
                '@type': 'AggregateRating',
                ratingValue: 0,
                reviewCount: 0,
              };
            }

            ldjsonContent = JSON.stringify(jsonldObject);
            ldjson_temp.script.push({
              innerHTML: ldjsonContent,
              type: 'application/ld+json',
            });
          }
        }
      }

      if (this.currentPageIn(['Category'])) {
        // WebPage
        ldjsonContent = {
          '@context': 'http://schema.org',
          '@type': 'WebPage',
          name: this.title,
          description: this.description,
          url: this.url,
        };
        ldjsonContent = JSON.stringify(ldjsonContent);
        ldjson_temp.script.push({
          innerHTML: ldjsonContent,
          type: 'application/ld+json',
        });

        // Breadcrumb List
        const breadcumbList = this.$store.state.category.breadcumbs || [];
        if (breadcumbList && breadcumbList.length) {
          // console.log(breadcumbList);
          const array_category = [];
          for (let i = 0; i < breadcumbList.length; i++) {
            const item_category = breadcumbList[i];
            const obj_category = {
              '@type': 'ListItem',
              position: i + 1,
              name: item_category.name,
            };

            if (i != breadcumbList.length - 1) {
              // console.log(`${this.$store.state.REVIEW_WEB_URL}/category/${item_category.id}/${item_category.name.replace(" ", "-").toLowerCase()}`);
              obj_category.item = `${this.$store.state.REVIEW_WEB_URL}/category/${item_category.id}/${item_category.name
                .replace(' ', '-')
                .toLowerCase()}`;
            }
            array_category.push(obj_category);
          }
          ldjsonContent = {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: array_category,
          };

          ldjsonContent = JSON.stringify(ldjsonContent);
          ldjson_temp.script.push({
            innerHTML: ldjsonContent,
            type: 'application/ld+json',
          });
        }
      }
    }

    if (this.currentPageIn(['ReviewDetail']) && this.isHaveReviewDetail) {
      const {
        details,
        share_image,
        product: { name },
      } = this.reviewDetail;
      const metaTitle = `Review SOCO by Sociolla - ${name}`;
      meta.title = metaTitle;
      meta.meta[0].content = metaTitle;
      meta.meta[7].content = metaTitle;
      meta.meta[15].content = metaTitle;
      meta.meta[1].content = details;
      meta.meta[8].content = details;
      meta.meta[16].content = details;
      if (share_image) {
        const { whatsapp, facebook } = share_image;
        if ((this.$route.query.from === 'wa') & whatsapp) {
          meta.meta[4].content = whatsapp;
          meta.meta[17].content = whatsapp;
        }
        if ((this.$route.query.from === 'fb') & facebook) {
          meta.meta[4].content = facebook;
          meta.meta[17].content = facebook;
        }
      }
    }

    let ldjson;
    if (this.currentPageIn(['BrandDetail', 'Search', 'Category'])) {
      if (ldjson_temp) {
        ldjson = ldjson_temp;
      }
    } else {
      if (ldjsonContent) {
        ldjson = {
          script: [{ innerHTML: ldjsonContent, type: 'application/ld+json' }],
        };
      }
    }

    if (ldjson) {
      meta = Object.assign({}, meta, ldjson);
    }

    this.$store.commit('setTitle', this.title);

    if (this.title && this.title != undefined && this.title != this.default_title) {
      setTimeout(() => {
        window.prerenderReady = true;
      }, 3000);
    }

    setTimeout(() => {
      window.prerenderReady = true;
    }, 20000);

    return meta;
  },
};
</script>
